// extracted by mini-css-extract-plugin
export var section = "styles-module--section--1pAQe";
export var title = "styles-module--title--1R6qO";
export var box = "styles-module--box--3XRnC";
export var images = "styles-module--images--3b0aW";
export var imageItem = "styles-module--imageItem--xPJTi";
export var footer = "styles-module--footer--2iKXI";
export var footerInner = "styles-module--footerInner--JBa0q";
export var place = "styles-module--place--1pauC";
export var location = "styles-module--location--16e8-";